
export class SocialUser {
  provider: string;
  id: string;
  email: string;
  name: string;
  photoUrl: string;
  firstName: string;
  lastName: string;
  authToken: string;
  idToken: string; // Reference https://developers.google.com/identity/sign-in/web/backend-auth
}

function SocialUser_tsickle_Closure_declarations() {
/** @type {?} */
SocialUser.prototype.provider;
/** @type {?} */
SocialUser.prototype.id;
/** @type {?} */
SocialUser.prototype.email;
/** @type {?} */
SocialUser.prototype.name;
/** @type {?} */
SocialUser.prototype.photoUrl;
/** @type {?} */
SocialUser.prototype.firstName;
/** @type {?} */
SocialUser.prototype.lastName;
/** @type {?} */
SocialUser.prototype.authToken;
/** @type {?} */
SocialUser.prototype.idToken;
}

